import React, { useCallback, useContext } from "react";
import { Box } from "@mui/material";
import { useIntl } from "react-intl";
import { CommunityAnalysis } from "features/metadesk";
import Back from "features/metadesk/components/Back";

const EcoScanDetailContainer = ({ type }) => {
  const { formatMessage } = useIntl();
  const renderContent = () => {
    if (type === "communityAnalysis") {
      return <CommunityAnalysis></CommunityAnalysis>;
    }
  };

  return (
    <Box>
      <Back noMt></Back>
      {renderContent()}
    </Box>
  );
};

export default EcoScanDetailContainer;
